import React from 'react';
import { Button } from '@components/Button';
import classNames from 'classnames';
import './IconButton.scss';

export const IconButton = ({ children, onClick, className }) => {
  return (
    <Button
      text=''
      color='default'
      size='small'
      className={classNames('c-icon-button', className)}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
